"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

exports.__esModule = true;

var react_1 = __importStar(require("react"));

var nama_icon_1 = require("../nama-icon");

require("./dropdown.scss");

;
var triggerActions;

(function (triggerActions) {
  triggerActions["toggle"] = "toggle";
  triggerActions["open"] = "open";
})(triggerActions = exports.triggerActions || (exports.triggerActions = {}));

var Dropdown = function Dropdown(_a) {
  var trigger = _a.trigger,
      items = _a.items,
      className = _a.className,
      selected = _a.selected,
      multiple = _a.multiple,
      onSelect = _a.onSelect,
      onOpen = _a.onOpen,
      onClose = _a.onClose,
      triggerAction = _a.triggerAction;

  var _b = react_1.useState(undefined),
      showDropdown = _b[0],
      setShowDropdown = _b[1];

  var _c = react_1.useState(undefined),
      listStyle = _c[0],
      setListStyle = _c[1];

  var triggerRef = react_1.useRef(null);
  react_1.useEffect(function () {
    var triggerElement = triggerRef.current;

    if (triggerElement) {
      triggerElement && setListStyle({
        top: triggerElement.clientHeight + "px",
        width: triggerElement.clientWidth + "px"
      });
    }
  }, [triggerRef, setListStyle]);
  react_1.useEffect(function () {
    if (showDropdown === true) {
      var triggerElement = triggerRef.current;
      triggerElement && setListStyle({
        top: triggerElement.clientHeight + "px",
        width: triggerElement.clientWidth + "px"
      });
      onOpen && onOpen();
    } else if (showDropdown === false) {
      onClose && onClose();
    }
  }, [showDropdown, onOpen, onClose, triggerRef, setListStyle]);

  var handleSelect = function handleSelect(item) {
    onSelect(item);

    if (!multiple) {
      setShowDropdown(false);
    }
  };

  var isSelected = function isSelected(item) {
    if (!selected) return false;

    if (Array.isArray(selected)) {
      return selected.some(function (selectedItem) {
        return selectedItem.value === item.value;
      });
    } else {
      return item.value === selected.value;
    }
  };

  return react_1["default"].createElement(react_1["default"].Fragment, null, react_1["default"].createElement("div", {
    className: "nama-dropdown" + (showDropdown ? ' show' : '') + (className ? ' ' + className : '')
  }, react_1["default"].createElement("div", {
    ref: triggerRef,
    className: "nama-dropdown__trigger",
    onClick: triggerAction && triggerAction === triggerActions.toggle ? function () {
      return setShowDropdown(!showDropdown);
    } : function () {
      return setShowDropdown(true);
    }
  }, trigger), react_1["default"].createElement("div", {
    className: 'nama-dropdown__list',
    style: listStyle
  }, items.map(function (item, idx) {
    if (item.value === 'divider') return react_1["default"].createElement("hr", {
      key: idx
    });
    var selected = isSelected(item);
    return react_1["default"].createElement("div", {
      key: item.value,
      className: "nama-dropdown__item" + (item.disabled ? ' disabled' : ''),
      onClick: function onClick() {
        return !item.disabled && handleSelect(item);
      }
    }, item.icon && react_1["default"].createElement(nama_icon_1.NamaIcon, {
      icon: item.icon,
      className: "optional-icon fill-grey-700"
    }), react_1["default"].createElement("span", {
      className: "item-label"
    }, item.label), selected ? react_1["default"].createElement(nama_icon_1.NamaIcon, {
      icon: multiple ? "CheckboxChecked" : "RadioSelected",
      className: "selected-icon fill-green-300"
    }) : multiple ? react_1["default"].createElement(nama_icon_1.NamaIcon, {
      icon: "CheckboxUnchecked",
      className: "selected-icon fill-grey-700"
    }) : react_1["default"].createElement("div", {
      className: "nama-icon selected-icon"
    }));
  }))), react_1["default"].createElement("div", {
    className: "nama-overlay" + (showDropdown ? ' show' : ''),
    onClick: function onClick() {
      return setShowDropdown(false);
    }
  }));
};

exports.Dropdown = Dropdown;
Dropdown.defaultProps = {
  multiple: false,
  triggerAction: triggerActions.toggle
};